import { getTreePathOfNode } from 'anodum';
import getAdvancedSelection from '../../text-formatting/accessors/get-advanced-selection';
import findNextNode from './find-next-node';

const isReverseDirectionAfterSelectionChange = (prevSelection, focusedElement) => {
  const currentSelection = getAdvancedSelection();
  const isBackwards = currentSelection.isBackwards();

  if (isBackwards) {
    if (currentSelection.anchorNode === prevSelection.anchorNode) {
      return currentSelection.anchorOffset < prevSelection.anchorOffset;
    }

    const nextNode = findNextNode(currentSelection.focusNode);

    return Boolean(nextNode && nextNode.contains(prevSelection.anchorNode));
  }

  if (
    (currentSelection.anchorNode === prevSelection.anchorNode ||
      currentSelection.anchorNode.firstChild === prevSelection.anchorNode) &&
    currentSelection.anchorOffset === prevSelection.anchorOffset
  ) {
    if (currentSelection.focusNode !== prevSelection.focusNode) {
      const nextNode = findNextNode(currentSelection.focusNode);
      if (
        nextNode === prevSelection.focusNode ||
        nextNode === prevSelection.focusNode.firstChild ||
        nextNode.firstChild === prevSelection.focusNode
      ) {
        return true;
      }
    } else if (currentSelection.focusOffset < prevSelection.focusOffset) {
      return true;
    }
  }

  if (currentSelection.isCollapsed && prevSelection.focusNode) {
    if (
      !focusedElement.contains(currentSelection.anchorNode) ||
      !focusedElement.contains(prevSelection.anchorNode)
    ) {
      return false;
    }

    const previousPath = getTreePathOfNode(prevSelection.anchorNode, focusedElement);
    const nextPath = getTreePathOfNode(currentSelection.anchorNode, focusedElement);

    for (let i = 0; i <= previousPath.length; i += 1) {
      if (previousPath[i] !== nextPath[i]) {
        return previousPath[i] >= nextPath[i];
      }
    }
  }

  return false;
};

export default isReverseDirectionAfterSelectionChange;
